import { Box, styled } from '@mui/material';

import { Spacing } from '@themes/spacing';

export const ActionsWrapper = styled(Box)`
  display: flex;
  align-items: center;
  gap: ${Spacing.xsmall};
`;
